/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Warm_Finch_SingInputs */

const en_mild_warm_finch_sing = /** @type {(inputs: Mild_Warm_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment Attributes`)
};

const de_mild_warm_finch_sing = /** @type {(inputs: Mild_Warm_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentarmerkmale`)
};

/**
* | output |
* | --- |
* | "Comment Attributes" |
*
* @param {Mild_Warm_Finch_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_warm_finch_sing = /** @type {((inputs?: Mild_Warm_Finch_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Warm_Finch_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_warm_finch_sing(inputs)
	return de_mild_warm_finch_sing(inputs)
});